<template>
  <v-card
    flat
    class="mx-auto rounded-lg"
    min-height="240"
    @click="navigateToDetailsPage(assessment._id)"
  >
    <div class="pa-3">
      <v-img
        height="140"
        :src="assessment.images ? getImage(assessment.images) : null"
        lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
        cover
      />
    </div>

    <v-card-title class="pt-0 pb-3">
      <p
        class="text-start body-2 textLight--text ma-0 text-ellipse-1"
        style="opacity: 0.8"
      >
        {{ getLocalisedValue(assessment.title) }}
      </p>
    </v-card-title>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex align-end">
        <v-icon color="primary"> mdi-book-open-variant</v-icon>

        <span class="primary--text ms-3">
          {{ totalQuestions }}

          {{ $t("quiz.questions") }}
        </span>
      </div>
    </v-card-text>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex justify-space-between">
        <span class="body-2 textLight--text text-truncate" style="opacity: 0.8">
          {{
            assessment.quiz && assessment.quiz.timeOut
              ? `${assessment.quiz.timeOut} mins`
              : "-"
          }}
        </span>

        <v-icon size="20">mdi-arrow-right</v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AvailableAssessmentCard",
  props: {
    assessment: {
      type: Object,
    },
  },
  computed: {
    totalQuestions() {
      return Math.min(
        this.assessment?.quiz?.questionAnswers?.length ?? 0,
        this.assessment?.quiz?.questionsDisplayedCount ?? 0
      );
    },
  },
  methods: {
    navigateToDetailsPage(id) {
      this.$router.push({ name: "AssessmentDetails", params: { id } });
    },
  },
};
</script>
